import icon from 'assets/img/icons/special-offers.svg';
import PagePopopCloseButton from 'components/page-components/PagePopopCloseButton';
import useActiveItem from 'hooks/useActiveItem';
import { useState } from 'react';
import { createAPI } from 'services/api/api';

const MakeOfferReview = ({ nextStep, setStep, offerData, closeWindow }) => {
  const api = createAPI();
  const {activeItem} = useActiveItem();
  const [isMakeOfferLoading, setIsMakeOfferLoading] = useState(false)

  const handleSubmit = () => {
    setIsMakeOfferLoading(true);
    const payload = {
      marketplace_listing_id: activeItem.marketplace_id,
      amount: Number(offerData.amount),
      expires_in_days: Number(offerData.days),
      expires_in_hours: Number(offerData.hours),
    }
    api.post(`/marketplace_offer`, payload)
      .then((response) => console.log(response.data))
      .then(() => nextStep())
      .catch((error) => {
        console.log('making offer error', error);
        setStep('fail');
      })
      .finally(() => setIsMakeOfferLoading(false));
  }

  const getOfferValidFor = (days, hours) => {
    const dayLabel = days === 1 ? 'day' : 'days';
    const hourLabel = hours === 1 ? 'hour' : 'hours';

    return `${days} ${dayLabel} ${hours} ${hourLabel}`;
  };

  return (
    <div className="modal-window__wrapper" onClick={(e) => e.stopPropagation()}>
      <PagePopopCloseButton close={closeWindow} />
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Review your offer</h5>
      </header>
      <form className="purchase-form">
        <output className="purchase-form__output">
          <span>Price</span>
          <span>${offerData.amount}</span>
        </output>
        <output className="purchase-form__output">
          <span>Offer valid for</span>
          <span>{getOfferValidFor(offerData.days, offerData.hours)}</span>
        </output>
        <footer className="modal-window__footer">
          <button className="modal-window__footer-close" type="button" onClick={() => setStep('create')}>Back</button>
          <button className={`modal-window__footer-submit ${isMakeOfferLoading ? 'loading' : ''}`} disabled={isMakeOfferLoading} type="button" onClick={handleSubmit}>Confirm</button>
        </footer>
      </form>
    </div>
  )
}

export default MakeOfferReview;
